import React from 'react';
// import {MasterLayout} from 'layout';
import {XuLyGiaiQuyetDon} from "modules/giai-quyet-don";

export default class TruongPhongThuHoiPage extends React.Component {

  render() {
    return (
      <XuLyGiaiQuyetDon status='DANG_GIAI_QUYET' truongPhongThuHoi={true} params={this.props.params} route={this.props.route}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/giai-quyet-don/TruongPhongThuHoiPage.jsx